import { IPagination } from 'app/types/common';

export interface IPerson {

}
export interface IPeopleState {
  readonly peopleById?: any;
  readonly peopleIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectPersonLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddPerson?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPersonIds?: string[];
  readonly currentPersonId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPeopleSelector extends IPeopleState {
  readonly currentPerson?: any;
  readonly currentFormPerson?: any;
  readonly peopleFilteredByTagInSelectFormat?: any;
  readonly peopleByIdInSelectFormat?: any;
}

export enum PeopleActionTypes {
  GET_ALL_PEOPLE_REQUESTED = 'redux-app/people/GET_ALL_PEOPLE_REQUESTED',
  GET_ALL_PEOPLE_PENDING = 'redux-app/people/GET_ALL_PEOPLE_PENDING',
  GET_ALL_PEOPLE_SUCCESS = 'redux-app/people/GET_ALL_PEOPLE_SUCCESS',
  GET_ALL_PEOPLE_FAIL = 'redux-app/people/GET_ALL_PEOPLE_FAIL',
  GET_PERSON_REQUESTED = 'redux-app/people/GET_PERSON_REQUESTED',
  GET_PERSON_PENDING = 'redux-app/people/GET_PERSON_PENDING',
  GET_PERSON_SUCCESS = 'redux-app/people/GET_PERSON_SUCCESS',
  GET_PERSON_FAIL = 'redux-app/people/GET_PERSON_FAIL',
  UPDATE_PERSON_REQUESTED = 'redux-app/people/UPDATE_PERSON_REQUESTED',
  UPDATE_PERSON_PENDING = 'redux-app/people/UPDATE_PERSON_PENDING',
  UPDATE_PERSON_SUCCESS = 'redux-app/people/UPDATE_PERSON_SUCCESS',
  UPDATE_PERSON_FAIL = 'redux-app/people/UPDATE_PERSON_FAIL',
  CREATE_PERSON_REQUESTED = 'redux-app/people/CREATE_PERSON_REQUESTED',
  CREATE_PERSON_PENDING = 'redux-app/people/CREATE_PERSON_PENDING',
  CREATE_PERSON_SUCCESS = 'redux-app/people/CREATE_PERSON_SUCCESS',
  CREATE_PERSON_FAIL = 'redux-app/people/CREATE_PERSON_FAIL',
  DELETE_PERSON_REQUESTED = 'redux-app/people/DELETE_PERSON_REQUESTED',
  DELETE_PERSON_PENDING = 'redux-app/people/DELETE_PERSON_PENDING',
  DELETE_PERSON_SUCCESS = 'redux-app/people/DELETE_PERSON_SUCCESS',
  DELETE_PERSON_FAIL = 'redux-app/people/DELETE_PERSON_FAIL',
  SELECT_PERSON_REQUESTED = 'redux-app/people/SELECT_PERSON_REQUESTED',
  TOGGLE_PERSON_CREATE_MODAL = 'redux-app/people/TOGGLE_PERSON_CREATE_MODAL',
}

export default null;
